import clearDataStorage from "./auth/clearDataStorage";
import appGlobalConfig from "@shared/config/app/appGlobal.config"; // VARAIBLES DE ENTORNO

const connection = ({ url = '', method = 'POST', headers = {}, body, signal, formData = false, credentials }) => {
    const defaultHeaders = new Headers({
        'X-Custom-Request': 'connection',
        'X-App-Origin': appGlobalConfig.CONFIG_MODULE.NAME_PROYECT,
        'X-App-Basename': appGlobalConfig.BASENAME,
        'client-id': appGlobalConfig.CLIENT_ID,
        'Accept-Charset': 'utf-8',
        ...(formData ? {} : { 'Content-Type': 'application/json' }),
        ...headers
    });

    const handleResponse = async (res) => {
        let parsedBody = null;
        if (res.status === 401) {
            clearDataStorage();
            const basename = (appGlobalConfig.BASENAME || '').replace(/\/$/, '');
            window.location.replace(`${basename}/login`);
        }
        try {
            parsedBody = await res.json();
        } catch (e) {
            const text = await res.text().catch(() => null);

            if (!text) {
                const error = new Error('Error al conectar con el servidor o respuesta inválida');
                error.status = res.status;
                throw error;
            }

            parsedBody = { message: text };
        }

        return {
            networkInfo: {
                status: res.status,
                ok: res.ok,
            },
            ...parsedBody,
        };
    };

    return fetch(url, {
        method,
        headers: defaultHeaders,
        body: formData ? body : JSON.stringify(body),
        signal,
        ...(credentials && { credentials })
    })
        .then(handleResponse)
        .then(data => data)
        .catch(err => {
            throw err;
        });
};

export default connection;
